// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"154":"59e10e9b","493":"083ca685","619":"7281b07c","823":"d9034a6c"}[chunkId] + ".chunk.js";
};